<template>
  <div>
    <div
      v-for="(row, index) in gridRows"
      :key="index"
    >
      <hr />
      <div class="flex gap-xs text-12 cursor-default">
        <span class="w-1/2">{{ row.title }}:</span>
        <b
          class="w-1/2"
          :class="{'!text-danger': row.danger}"
        >
          {{ row.result }}
        </b>
      </div>
      <hr v-if="index === gridRows.length - 1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetInfoGrid',
  props: {
    gridRows: {
      type: Array,
      required: true,
    },
  },
};
</script>
